import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import ResponsiveImage from 'components/images/responsive-image'
import LocationDetails from 'components/pomelo-pickup/pickup-location/location-details'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import Icon from 'components/common/icon'
import env from 'config/env'
import Typo from 'constants/typography'
import styles from './styles.scss'

// eslint-disable-next-line react/prefer-stateless-function
class PomeloPickUpDetailModal extends React.Component {
  render() {
    const { close, location, t } = this.props

    if (!location) {
      return null
    }

    let { distance_from_user } = location

    if (distance_from_user) {
      if (distance_from_user < 0.5) {
        distance_from_user = 'less than a km'
      } else if (distance_from_user < 5) {
        distance_from_user = `${Math.round(distance_from_user)} km`
      } else if (distance_from_user < 50000) {
        distance_from_user = null
      } else {
        distance_from_user = 'N/A'
      }
    }

    return (
      <div className="pomelo-pickup-detail-modal__container">
        <style jsx>{styles}</style>
        <Icon
          className="close-icon"
          src={ICONS.close}
          size={ICON_SIZE.medium}
          onClick={close}
        />
        <ResponsiveImage
          imgRatio={0.625}
          src={`${env.IMG_HOST}${location?.images?.store?.primary?.landscape}`}
        />
        <div className="ppdmc__location-container">
          <div className="ppdmc__information-area">
            <span className={clsx(Typo.caption, 'ppdmc__pickup-district')}>
              {location.district}
            </span>
            <span className={clsx(Typo.subtitle2, 'ppdmc__pickup-name')}>
              {location.alias}
            </span>
            <span className={clsx(Typo.subtitle2, 'ppdmc__pickup-type')}>
              {location.subtype || location.type}
            </span>
          </div>
          <div className="ppdmc__icon-area">
            {!!distance_from_user && (
              <span className={clsx(Typo.caption, 'ppdmc__distance')}>
                {distance_from_user}
              </span>
            )}
          </div>
        </div>
        <LocationDetails
          fromPickupDetailModal
          isPhone
          location={location}
          t={t}
        />
      </div>
    )
  }
}

PomeloPickUpDetailModal.defaultProps = {
  location: undefined,
}

PomeloPickUpDetailModal.propTypes = {
  close: PropTypes.func.isRequired,
  location: PropTypes.shape({
    alias: PropTypes.string,
    district: PropTypes.string,
    distance_from_user: PropTypes.number,
    images: PropTypes.shape({
      store: PropTypes.shape({
        primary: PropTypes.shape({
          landscape: PropTypes.string,
        }),
      }),
    }),
    subtype: PropTypes.string,
    type: PropTypes.string,
  }),
  t: PropTypes.func.isRequired,
}

export default PomeloPickUpDetailModal
